import { getFeature } from 'Cloud/Application/FeaturesEs6';

interface TypeOfDocumentVieverConfig {
    attach?: boolean;
    document?: boolean;
    pdf?: boolean;
}

const EDIT_MENU_BUTTON_REDESIGN_CONFIG = getFeature('edit-menu-button-redesign') as TypeOfDocumentVieverConfig;

export const EDIT_MENU_BUTTON_REDESIGN_ATTACH = EDIT_MENU_BUTTON_REDESIGN_CONFIG?.attach || false;

export const EDIT_MENU_BUTTON_REDESIGN_DOCUMENT = EDIT_MENU_BUTTON_REDESIGN_CONFIG?.document || false;

export const EDIT_MENU_BUTTON_REDESIGN_PDF = EDIT_MENU_BUTTON_REDESIGN_CONFIG?.pdf || false;
